import { color } from "framer-motion";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

const Category0 = ({ data }) => {
  // Dummy data for categories with icons
  const [backgroundColor, setBackgroundColor] = useState("");
  const [title, setTitle] = useState("");
  const [titleColor, setTitleColor] = useState("");
  const [titleFont, setTitleFont] = useState("");
  const [titleSize, setTitleSize] = useState("");
  const [webbackgrounColor, setWebBackgrounColor] = useState("");
  const [webfont, setWebFont] = useState("");
  const [webColor, setWebColor] = useState("");
  const [titleAlignment, setTitleAlignment] = useState("");
  const [cornerRadius, setCornerRadius] = useState("");
  const [margin, setMargin] = useState("");
  const [padding, setPadding] = useState("");
  const [labelPosition, setLabelPosition] = useState("");
  const [labelFont, setLabelFont] = useState("");
  const [labelColor, setLabelColor] = useState("");

  useEffect(() => {
    setBackgroundColor(component.background_color);
    setTitle(component.title);
    setTitleColor(component.title_color);
    setTitleFont(component.title_font);
    setTitleSize(component.title_size);
    setWebBackgrounColor(component.web_background_color);
    setWebFont(component.web_title_font);
    setWebColor(component.web_title_color);
    setTitleAlignment(component.title_alignment);
    setCornerRadius(component.corner_radius);
    setMargin(component.item_margin);
    setPadding(component.item_padding);
    setLabelPosition(component.label_position);
    setLabelFont(component.label_font);
    setLabelColor(component.label_color);
    
    
  }, []);


  

  const categories = data["get_home_component_details"]["content"];
  const component = data;


  const loadGoogleFont = (fontName) => {
    if (!fontName) return;

    const f = fontName.trim();
    const lower = f.toLowerCase();

    if (lower === "sans" || lower === "serif" || lower === "mono") return;

    const formatted = f.replace(/\s+/g, "+");
    const id = `gf-${formatted.toLowerCase()}`;

    if (document.getElementById(id)) return;

    const link = document.createElement("link");
    link.id = id;
    link.rel = "stylesheet";
    link.href = `https://fonts.googleapis.com/css2?family=${formatted}&display=swap`;
    document.head.appendChild(link);
  };

  const getFontFamily = (font) => {
    if (!font) return "inherit";

    const f = font.toLowerCase().trim();

    if (f === "sans") return "ui-sans-serif, system-ui, -apple-system, sans-serif";
    if (f === "serif" || f === "sherif")
      return 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif';
    if (f === "mono")
      return 'ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace';

    return font;
  };

    useEffect(() => {
    loadGoogleFont(webfont);
    loadGoogleFont(titleFont);
    loadGoogleFont(labelFont);
  }, [webfont, titleFont]);
 

  const truncateNameMobile = (name) => {
    return name.length > 7 ? name.substring(0, 7) + "..." : name;
  };

  const truncateNameDesktop = (name) => {
    return name.length > 12 ? name.substring(0, 12) + "..." : name;
  };

  const chunkArray = (array, size) => {
    return array.length > 0
      ? Array.from({ length: Math.ceil(array.length / size) }, (_, index) =>
          array.slice(index * size, index * size + size)
        )
      : [];
  };

  

  const chunkedCategories = chunkArray(categories, 8);

  return (
    <div className="py-4 mx-auto " style={{ background: webbackgrounColor }}>
      <div
        className={`text-2xl font-bold ${
          titleAlignment === "center"
            ? "text-center"
            : titleAlignment === "start"
            ? "text-left"
            : "text-center"
        }`}
        style={{
          color: webColor || titleColor,
          fontFamily: getFontFamily(webfont),
          textSizeAdjust: titleSize,
        }}
      >
        {title}
      </div>

      {/* Desktop View */}
      <div
        className="flex-col hidden gap-4 lg:flex"
        style={{ borderRadius: cornerRadius, margin: margin, padding: padding }}
      >
        {chunkedCategories.map((row, rowIndex) => (
          <div
            key={rowIndex}
            className={`flex gap-2 ${
              row.length < 8 ? "justify-center" : "grid grid-cols-8"
            }`}
          >
            {row.map((category) => (
              <div
                key={category.maincategory_auto_id}
                className="p-3 text-center transition-all duration-300 transform rounded-lg shadow-md bg-gradient-to-br from-blue-50 to-purple-50 hover:shadow-lg hover:scale-105"
              >
                <Link
                  to={`/maincategory/${category.maincategory_auto_id}`}
                  className="flex flex-col items-center text-gray-800 no-underline hover:text-blue-600"
                >
                  <span
                    className={`text-lg font-semibold`}
                    style={{
                      color: labelColor || '#000000',
                      fontFamily: getFontFamily(labelFont),
                      
                    }}
                  >
                    {truncateNameDesktop(category.main_category_name)}
                  </span>
                </Link>
              </div>
            ))}
          </div>
        ))}
      </div>

      {/* Mobile View */}
      <div
        className="grid grid-cols-3 gap-2 lg:hidden"
        style={{
          background: webbackgrounColor,
          margin: margin,
          padding: padding,
          borderRadius: cornerRadius,
        }}
      >
        {categories.map((category) => (
          <div
            key={category.maincategory_auto_id}
            className="p-3 text-center transition-all duration-300 transform rounded-lg shadow-md bg-gradient-to-br from-blue-50 to-purple-50 hover:shadow-lg hover:scale-105"
          >
            <Link
              to={`/maincategory/${category.maincategory_auto_id}`}
              className="flex flex-col items-center text-gray-800 no-underline hover:text-blue-600"
            >
              <span
                className="text-sm font-medium"
                style={{ color: labelColor, fontFamily: getFontFamily(labelFont) }}
              >
                {truncateNameMobile(category.main_category_name)}
              </span>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Category0;
